import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Box,
  Typography,
  Tooltip,
} from "@mui/material";
import { EventRepeat } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { Transaction } from "../utils/types";
import { useMedia } from "../context/MediaContext";
import SettleCard from "./SettleCard";
import StatusPill from "./StatusPill";
import FileCopyIcon from "@mui/icons-material/FileCopy";
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return {
    date: date.toLocaleDateString("ru-RU"),
    time: date.toLocaleTimeString("ru-RU", { hour12: false }),
  };
};

const SettleTable: React.FC<{
  transactions: Transaction[];
}> = ({ transactions }) => {
  const theme = useTheme();
  const { isTablet } = useMedia();
  const handleCopyClick = (value: string) => {
    navigator.clipboard.writeText(value);
  };
  return isTablet ? (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      {transactions.map((el) => (
        <SettleCard t={el} />
      ))}
    </Paper>
  ) : (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead
          sx={{
            backgroundColor: theme.palette.table.head,
          }}
        >
          <TableRow>
            {["ID", "Статус", "Тип", "Сумма", "Дата"].map((title) => {
              return <TableCell key={title}>{title}</TableCell>;
            })}
          </TableRow>
        </TableHead>

        <TableBody>
          {transactions.map((t, index) => {
            const date = formatDate(t.created_at);

            return (
              <TableRow
                key={t.id}
                hover
                sx={{
                  backgroundColor:
                    index % 2 === 0
                      ? theme.palette.action.selected
                      : "transparent",
                  transition: "background-color 0.15s",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
              >
                <TableCell sx={{ maxWidth: "100px" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="body1" sx={{ mr: 1 }}>
                      {t.id}
                    </Typography>
                    <Tooltip title="Copy">
                      <IconButton onClick={() => handleCopyClick(t.id)}>
                        <FileCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
                <TableCell>
                  <StatusPill status={t.status} />
                </TableCell>

                <TableCell>{t.transaction_type}</TableCell>

                <TableCell align="right">
                  <Typography variant="body2" fontWeight={600}>
                    {t.start_amount.toLocaleString()}
                    <Typography
                      component="span"
                      variant="caption"
                      sx={{ ml: 0.5 }}
                    >
                      {t.currency}
                    </Typography>
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" fontSize="0.8rem">
                    {date.date}
                  </Typography>
                  <Typography variant="caption" fontSize="0.7rem">
                    {date.time}
                  </Typography>
                  {t.updated_at && (
                    <Tooltip
                      title={`Обновлено: ${formatDate(t.updated_at).date}`}
                    >
                      <EventRepeat
                        sx={{ fontSize: 14, ml: 0.5, color: "grey" }}
                      />
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SettleTable;
